

































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import DefaultLayout from '../../layouts/DefaultLayout.vue';
import HeroBar from '@/components/base/HeroBar.vue';
import { Action, State } from 'vuex-class';
import {
  CplusCriteria,
  CreateProjectRequestPayload,
  CreateProjectResponsePayload,
  RecurrenceSettingPayload,
  Site,
  ProjectDetailPayload,
  DataCollectionPeriodDTO,
  UpdateProjectCriteriaRequestPayload,
  ProjectSite,
  UpdateCriteriaDTO,
  CreateProjectParticipantPayload,
  ParticipationLevelEnum,
  ProjectSettingResponsePayload,
  DataCollectionPeriodSettingsPayload,
  ParticipantListDTO,
} from '@/store/modules/projects/types/projects.types';
import { isDifferent, isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import AuditCriteriaList from '@/views/Project/components/AuditCriteriaList.vue';
import ProjectCreationExitModal from '@/views/Project/components/ProjectCreationExitModal.vue';
import { RootState } from '@/store/store';
import { ToastProgrammatic as Toast } from 'buefy';
import SiteSettings from '@/views/Project/components/SiteSettings.vue';
import ParticipantSettings from '@/views/Project/components/ParticipantSettings.vue';
import RecurrenceSettings from '@/views/Project/components/RecurrenceSettings.vue';
import InviteParticipants from './components/steps/InviteParticipants.vue';
import SelectSite from './components/steps/SelectSite.vue';
import SelectCriteria from './components/steps/SelectCriteria.vue';
import BaseDialog from '../../components/base/BaseDialog.vue';
import { Route } from 'vue-router';
import { AxiosError } from 'axios';
import { get as _get } from 'lodash';
import moment from 'moment';
import {
  JBICriteriaDTO,
  UpdatedJBICriteriaAcknowledgement,
} from '../../store/modules/projects/types/projects.types';
import { cloneData } from '@/utils/general.util';
import { orderByUtil } from '@/jbi-shared/util/sort.util';
import { SortOrder } from '@/jbi-shared/types/search.types';
import JBICriteriaSelection from '../Audit/components/JBICriteriaSelection.vue';
import {
  AuditSamplingType,
  RecurrenceType,
} from '@/jbi-shared/types/project.types';
import { PacesParticipantRoles } from '@/jbi-shared/types/paces-project.types';

Component.registerHooks(['beforeRouteLeave']);

@Component({
  components: {
    RecurrenceSettings,
    ParticipantSettings,
    SiteSettings,
    DefaultLayout,
    HeroBar,
    AuditCriteriaList,
    JBICriteriaSelection,
    ProjectCreationExitModal,
    InviteParticipants,
    SelectSite,
    SelectCriteria,
  },
})
export default class ProjectCreatePage extends Vue {
  public projectTitle: string = '';
  public selectedCriteriaArray: CplusCriteria[] = [];
  public updatedJbiCriteriaList: JBICriteriaDTO[] = [];
  public showUpdatedJbiCriteriaNotification: boolean = false;
  public projectSites: Site[] = [];
  public selectedParticipantArray: CreateProjectParticipantPayload[] = [];
  public projectExpiry: any = null;
  public defaultEndDate: any = moment(new Date()).add(1, 'M');
  public dataCollectionPeriodDateTotal: DataCollectionPeriodDTO = {
    auditNumber: 1,
    auditName: 'Baseline',
    startDate: new Date(),
    endDate: this.defaultEndDate.subtract(1, 'd').toDate(),
    auditCriteriaIds: [],
    auditSiteIds: [],
    auditParticipants: [],
  };
  public recurrenceSetting: RecurrenceSettingPayload = {
    recurrenceType: RecurrenceType.ONE_OFF,
    multipleRecurrenceType: null,
    auditSamplingType: AuditSamplingType.TARGET_SAMPLE_SIZE,
    interval: 1,
    auditNumber: 1,
    scheduledRecurrenceStartDate: new Date(),
    scheduledRecurrenceEndDate: null,
    enableGrip: true,
    dataCollectionPeriodSettings: {
      0: this.dataCollectionPeriodDateTotal,
    },
  };

  public stepsIndex: number = 0;
  public perPage = 50;
  public page = 1;
  public isCreated = false;
  public showRecurrenceSetting: boolean = false;
  public deletedCriteriaList: number[] = [];
  public saveAsDraftLabel: string = '';
  public nextLabel: string = '';
  public isPageLoading: boolean = false;
  public projectLoadingDialog: any;
  public recurrenceSettingKey: number = Math.floor(Math.random() * 999);
  public isAuditCycleDataValidForAllCycles: boolean = false;

  public createProjectLabel: string = '';

  @Action('projects/getDraftProjectDetail')
  public getDraftProjectDetail!: (draftProjectId: number) => void;

  @State((state) => state.projects.projectDetail)
  public projectDetail!: ProjectDetailPayload;

  @Action('projects/getUpdatedJBICriteriaWithAcknowledgement')
  public getUpdatedJBICriteriaWithAcknowledgement!: (projectId: number) => void;

  @State((state) => state.projects.updatedJBICriteriaListWithAcknowledgment)
  public updatedJBICriteriaListWithAcknowledgment!: UpdatedJBICriteriaAcknowledgement;

  @Action('projects/createProject')
  public createProject!: (payload: CreateProjectRequestPayload) => void;

  @Action('projects/createProjectById')
  public createProjectById!: (payload: CreateProjectRequestPayload) => void;

  @Action('projects/saveDraft')
  public saveDraft!: (payload: CreateProjectRequestPayload) => void;

  @Action('projects/updateDraft')
  public updateDraft!: (payload: CreateProjectRequestPayload) => void;

  @Action('projects/updateProjectCriterias')
  public updateProjectCriterias!: (
    payload: UpdateProjectCriteriaRequestPayload,
  ) => void;

  @State((state: RootState) => state.projects.createdProject)
  public createdProject!: CreateProjectResponsePayload;

  @State((state: RootState) => state.projects.apiState.createProject)
  public createProjectState!: boolean;

  @Action('projects/saveProjectSettingFormData')
  public saveProjectSettingFormData!: (
    payload: RecurrenceSettingPayload | undefined,
  ) => void;

  @State((state) => state.projects.projectSettingForm)
  public projectSettingForm!: RecurrenceSettingPayload;

  public goToStep(step: number) {
    this.stepsIndex = step; // Set active step to the desired index
  }

  @Watch('stepsIndex')
  public onStepIndexChange() {
    if (this.stepsIndex === 3) {
      this.showRecurrenceSetting = true;
      this.recurrenceSettingKey++;
    } else if (this.showRecurrenceSetting) {
      this.saveProjectSettingFormData(this.recurrenceSetting);
    }
  }

  @Watch('createProjectState.error')
  @isDifferent
  @isTruthy
  public onCreateProjectError(error: AxiosError) {
    this.isPageLoading = false;
    this.projectLoadingDialog.close();
    Toast.open({
      message: _get(error, 'response.data.message', 'Error'),
      position: 'is-top',
      type: 'is-dark',
    });
  }

  @Watch('createProjectState.success')
  @isDifferent
  @isTruthy
  public onCreateProjectSuccess() {
    // to bypass routeLeave
    this.isCreated = true;
    this.isPageLoading = false;
    this.projectLoadingDialog.close();
    const checkDraft = this.createdProject.project.status === 'Draft';
    if (checkDraft) {
      Toast.open({
        message: `Your project has been saved as a draft`,
        position: 'is-top',
        type: 'is-dark',
      });
      setTimeout(() => {
        this.$router.push({
          name: 'project-me',
        });
      }, 200);
    } else {
      const newProjectId = this.createdProject.project.id.toString();
      if (this.selectedParticipantArray.length > 0) {
        this.$buefy.modal.open({
          parent: this,
          component: BaseDialog,
          hasModalCard: true,
          trapFocus: true,
          props: {
            title: 'Project Successfully Created',
            content: `Invitation emails have been sent to all participants.`,
            confirmButton: false,
            cancelButtonText: 'OK',
          },
        });
      }
      setTimeout(() => {
        this.$router.push({
          name: 'project-details',
          params: {
            projectId: newProjectId,
          },
        });
      }, 200);
    }
  }

  @Watch('projectDetail')
  @isTruthy
  public watchProjectDetails(value: ProjectDetailPayload) {
    if (this.draftProjectId) {
      const {
        title,
        criterias,
        projectSites,
        participants,
        settings,
      }: ProjectDetailPayload = cloneData(this.projectDetail);

      this.projectTitle = title;
      this.transformCriterias(criterias);
      this.transformSites(projectSites);
      if (participants) {
        this.transformParticipants(participants);
      }

      if (settings && settings[0]) {
        this.transformSettings(settings[0]);
      } else {
        this.showRecurrenceSetting = true;
      }

      this.stepsIndex = this.stepCalculator();
    }
  }

  public mounted(): void {
    this.showUpdatedJbiCriteriaNotification = false;
    if (this.draftProjectId) {
      this.getDraftProjectDetail(this.draftProjectId);
      this.getUpdatedJBICriteriaWithAcknowledgement(this.draftProjectId);
    } else {
      // clear form store in state
      this.saveProjectSettingFormData(undefined);
    }
  }

  public stepCalculator() {
    if (
      this.projectTitle === '' ||
      this.selectedCriteriaArray.length === 0 ||
      this.updatedJbiCriteriaList.length > 0
    ) {
      return 0;
    }
    if (this.projectSites.filter(Boolean).length === 0) {
      return 1;
    }
    if (this.selectedParticipantArray.length === 0) {
      return 2;
    }
    return 3;
  }

  public handleRecurrenceSettingUpdate(newValue: RecurrenceSettingPayload) {
    if (newValue.scheduledRecurrenceStartDate) {
      newValue.scheduledRecurrenceStartDate =
        newValue.scheduledRecurrenceStartDate;
    }
    if (newValue.scheduledRecurrenceEndDate) {
      newValue.scheduledRecurrenceEndDate = newValue.scheduledRecurrenceEndDate;
    }
    this.recurrenceSetting = newValue;
  }

  public handleCycleDataForm(isValid: boolean) {
    this.isAuditCycleDataValidForAllCycles = isValid;
  }

  public openJBICriteriaSelectionTemplate() {
    this.$buefy.modal.open({
      parent: this,
      component: JBICriteriaSelection,
      fullScreen: true,
      hasModalCard: false,
      trapFocus: true,
      animation: 'unset',
      props: {
        projectName: this.projectTitle,
        isCreateProject: true,
        isProjectLevel: true,
        selectedCriteriaArray: this.selectedCriteriaArray,
      },
      events: {
        updateSelectedCriteriaArray: (newValue: UpdateCriteriaDTO) => {
          this.handleSelectedCriteriaArray(newValue.emitCriteriaArray);
        },
      },
    });
  }

  public handleSelectedCriteriaArray(newValue: any) {
    const updatedValue: any[] = [];
    let tempIdCounter = -1;
    newValue.forEach((value: any) => {
      const dirtyValue = cloneData(value);
      if (!dirtyValue.id || dirtyValue.id === '') {
        dirtyValue.id = dirtyValue.isNewCriteria
          ? tempIdCounter--
          : value.criteriaDetails
          ? value.criteriaDetails.id
          : null;
        if (!dirtyValue.id || dirtyValue.id === '') {
          dirtyValue.id = tempIdCounter--;
        }
      }
      updatedValue.push(dirtyValue);
    });

    this.selectedCriteriaArray = cloneData(updatedValue);
  }

  public isAuditIntervalInValid(): boolean {
    return (
      this.recurrenceSetting.interval !== undefined &&
      this.recurrenceSetting.recurrenceType === RecurrenceType.MULTIPLE &&
      this.recurrenceSetting.interval < 1
    );
  }

  public isAuditNumberInValid(): boolean {
    return (
      this.recurrenceSetting.auditNumber !== undefined &&
      this.recurrenceSetting.recurrenceType === RecurrenceType.MULTIPLE &&
      (this.recurrenceSetting.auditNumber < 1 ||
        this.recurrenceSetting.auditNumber > 10)
    );
  }

  public isRecurrenceSettingInValid() {
    return this.isAuditIntervalInValid() || this.isAuditNumberInValid();
  }

  public checkInvalidDataSelection(): boolean {
    let error = false;
    // Can't proceed if title is empty
    if (this.stepsIndex === 0 && this.projectTitle === '') {
      this.nextLabel = 'Project title is required';
      return true;
    } else if (
      // Can't proceed is no site is selected
      this.stepsIndex === 1 &&
      this.projectSites.some((site) => typeof site !== 'object')
    ) {
      this.nextLabel = 'Site must be selected';
      error = true;
    } else if (this.stepsIndex === 3) {
      // Can't proceed if no criteria is selected
      if (this.selectedCriteriaArray.length === 0) {
        this.nextLabel = 'Criteria must be selected';
        error = true;
      } else if (
        (this.recurrenceSetting.recurrenceType === RecurrenceType.MULTIPLE &&
          this.isRecurrenceSettingInValid()) ||
        !this.isAuditCycleDataValidForAllCycles
      ) {
        this.nextLabel = 'Invalid data collection period';
        error = true;
      } else if (
        this.recurrenceSetting.recurrenceType !== RecurrenceType.MULTIPLE &&
        !this.isAuditCycleDataValidForAllCycles
      ) {
        this.nextLabel = 'Invalid data collection period';
        error = true;
      }
    } else {
      this.nextLabel = '';
    }

    return error;
  }

  public checkEmptySitesOrCriteria(): boolean {
    if (
      this.projectSites.filter(Boolean).length === 0 ||
      this.selectedCriteriaArray.length === 0
    ) {
      return true;
    }
    return false;
  }

  /**
   * Uses the checkInvalidDataSelection method to determine if the form is valid
   */
  get validateForm() {
    return this.checkInvalidDataSelection();
  }

  get validateSaveAsDraft() {
    let error = false;
    if (this.projectTitle === '') {
      this.saveAsDraftLabel = 'Project title is required';
      error = true;
    }
    if (
      this.stepsIndex === 3 &&
      this.recurrenceSetting.recurrenceType === RecurrenceType.MULTIPLE &&
      this.isRecurrenceSettingInValid()
    ) {
      this.saveAsDraftLabel = 'Invalid data collection period';
      error = true;
    }

    return error;
  }

  /** Formats criteria to include only the required fields: title and uniqueCriteriaId. */
  get formattedCriteria() {
    return this.selectedCriteriaArray.map((criteria) => {
      return {
        title: criteria.document
          ? `${criteria.document.id} || ${criteria.title}`
          : criteria.title,
        uniqueCriteriaId: criteria.criteriaDetails
          ? criteria.id
          : criteria.uniqueCriteriaId,
      };
    });
  }

  /** Formats sites to include only the required fields: name and id. */
  get formattedSites() {
    return this.projectSites.map((projectSite) => {
      return {
        id: projectSite.id,
        name: projectSite.name,
      };
    });
  }

  /**
   * Filters participants based on role (as Data Collector) and project level,
   * where project level is determined by the absence of an audit (!audit).
   * Formats the result to include only the required fields: email and siteIds.
   */
  get formattedDataCollectors() {
    return (
      this.selectedParticipantArray
        // Filter to only include "Data Collector" roles
        .filter(
          (participant) =>
            participant.assignedRole === PacesParticipantRoles.DataCollector,
        )
        .map((participant) => {
          return {
            email: participant.email,
            siteIds: participant.assignedSiteIds || [],
          };
        })
    );
  }

  public handleSubmit() {
    this.projectLoadingDialog = this.getProjectLoadingDialog();
    const postRequestPayload: CreateProjectRequestPayload = {
      projectTitle: this.projectTitle.trim(),
      auditCriterias: this.selectedCriteriaArray,
      sites: this.projectSites.filter(Boolean),
      participants: this.selectedParticipantArray,
      recurrenceSetting: this.recurrenceSetting,
    };

    if (this.draftProjectId) {
      postRequestPayload.projectId = this.draftProjectId;
      this.createProjectById(postRequestPayload);
    } else {
      this.createProject(postRequestPayload);
    }

    // clear form store in state
    this.saveProjectSettingFormData(undefined);
  }

  public getProjectLoadingDialog() {
    this.isPageLoading = true;
    return this.$buefy.modal.open({
      parent: this,
      component: BaseDialog,
      hasModalCard: true,
      trapFocus: true,
      props: {
        title: 'Project creation is in progress',
        content: 'Please wait for the project to be created.',
        confirmButton: false,
        cancelButton: false,
        showCloseButton: false,
      },
    });
  }

  public handleSaveDraft() {
    this.projectLoadingDialog = this.getProjectLoadingDialog();
    const postDraftRequestPayload: CreateProjectRequestPayload = {
      projectTitle: this.projectTitle.trim(),
      auditCriterias: this.selectedCriteriaArray,
      sites: this.projectSites.filter(Boolean),
      participants: this.selectedParticipantArray,
      recurrenceSetting: this.recurrenceSetting,
    };
    if (this.draftProjectId) {
      this.updateDraft({
        ...postDraftRequestPayload,
        projectId: this.draftProjectId,
      });
    } else {
      this.saveDraft(postDraftRequestPayload);
    }
  }

  get draftProjectId(): number | null {
    return +this.$route.params.projectId;
  }

  public transformCriterias(criterias: any[]) {
    this.selectedCriteriaArray = [];
    criterias.forEach((criteria) => {
      const transformedCriteria: CplusCriteria = {
        id: criteria.id,
        title: criteria.title,
        type: criteria.criteriaType,
        criteriaOptions: JSON.parse(criteria.criteriaOptions).filter(
          (option: any) => {
            return option !== 'N/A';
          },
        ),
        booleanOptions: JSON.parse(criteria.criteriaOptions),
        range: JSON.parse(criteria.criteriaOptions),
        checkboxesOptions: JSON.parse(criteria.criteriaOptions),
        document: {
          id: criteria.documentId,
          title: criteria.documentName,
          description: criteria.description,
        },
        guide: criteria.guide,
        tags: criteria.tags,
        bestPracticeRecommendations: [],
        criteriaDetails: criteria,
        order: criteria.order,
        sourceLink: criteria.sourceLink,
        isChanged: criteria.isChanged,
      };

      // Adding updated JBI Criteria Details for Draft Project Criteria
      if (
        this.draftProjectId &&
        this.updatedJbiCriteriaList &&
        this.updatedJbiCriteriaList.length > 0
      ) {
        this.updatedJbiCriteriaList.forEach(
          (updatedJbiCriteria: JBICriteriaDTO) => {
            if (
              updatedJbiCriteria.connectPlusCriteriaId ===
              +criteria.connectPlusId
            ) {
              transformedCriteria.updatedJbiCriteria = updatedJbiCriteria;
            }
          },
        );
      }
      this.selectedCriteriaArray.push(transformedCriteria);
    });
  }

  public getTags(tagInfo: any) {
    const tags: string[] = [];
    Object.keys(tagInfo).forEach((key: string) => {
      const tagList = tagInfo[key];
      tagList.forEach((tag: string) => {
        tags.push(tag.charAt(0).toUpperCase() + tag.slice(1));
      });
    });
    return tags;
  }

  public transformSites(sites: ProjectSite[]) {
    this.projectSites = [];
    for (const projectSite of sites) {
      // skip deleted project sites
      if (projectSite.isDeleted) {
        continue;
      }

      const transformedSite: Site = {
        id: projectSite.site.id,
        name: projectSite.site.name,
        address: projectSite.site.address,
        description: projectSite.site.description,
        isIdentifierRequired: projectSite.isIdentifierRequired,
      };
      this.projectSites.push(transformedSite);
    }
    this.projectSites = this.projectSites.sort(
      orderByUtil(['id'], [SortOrder.ASC]),
    );
  }

  public transformParticipants(participants: ParticipantListDTO[]) {
    if (participants.length > 0) {
      participants.forEach((participant) => {
        if (
          participant.participantRole !==
          PacesParticipantRoles.ProjectAdministrator
        ) {
          const transformParticipant: CreateProjectParticipantPayload = {
            email: participant.userEmail,
            assignedRole: participant.participantRole,
            assignedSiteIds:
              participant.participantSites.map((ps) => ps.site) || [],
            level: ParticipationLevelEnum.Project,
          };
          this.selectedParticipantArray.push(transformParticipant);
        }
      });
    }
  }

  public transformSettings(settings: ProjectSettingResponsePayload) {
    const currentActiveSetting = settings;
    const dataCollectionPeriodSettings: DataCollectionPeriodSettingsPayload = {};
    Object.keys(currentActiveSetting.dataCollectionPeriodSettings).forEach(
      (payload, index) => {
        const data: DataCollectionPeriodDTO =
          currentActiveSetting.dataCollectionPeriodSettings[index];

        dataCollectionPeriodSettings[index] = {
          ...data,
          auditCriteriaIds: data.auditCriteriaIds
            ? data.auditCriteriaIds
            : this.formattedCriteria.map((cr) => cr.uniqueCriteriaId),
          auditSiteIds: data.auditSiteIds
            ? data.auditSiteIds
            : this.formattedSites.map((s) => s.id),
          auditParticipants: data.auditParticipants
            ? data.auditParticipants
            : this.formattedDataCollectors,
        };
      },
    );

    const draftRecurrenceSetting = {
      recurrenceType: currentActiveSetting.recurrenceType,
      scheduledRecurrenceStartDate:
        currentActiveSetting.scheduledRecurrenceStartDate,
      scheduledRecurrenceEndDate:
        currentActiveSetting.scheduledRecurrenceEndDate,
      multipleRecurrenceType: currentActiveSetting.multipleRecurrenceType,
      auditSamplingType: currentActiveSetting.samplingType
        ? currentActiveSetting.samplingType
        : AuditSamplingType.TARGET_SAMPLE_SIZE,
      interval: currentActiveSetting.interval
        ? currentActiveSetting.interval
        : 1,
      auditNumber: currentActiveSetting.auditNumber
        ? currentActiveSetting.auditNumber
        : 1,
      enableGrip: true,
      dataCollectionPeriodSettings,
    };

    this.recurrenceSetting = cloneData(draftRecurrenceSetting);
    this.saveProjectSettingFormData(draftRecurrenceSetting);
    this.showRecurrenceSetting = true;
  }

  public contentHasChanged() {
    if (
      this.projectTitle.length > 0 ||
      this.selectedCriteriaArray.length > 0 ||
      this.projectSites.filter(Boolean).length > 0 ||
      this.selectedParticipantArray.length > 0
    ) {
      return true;
    }
  }

  public handleDeletedCriteria(criteria: any) {
    if (criteria.criteriaDetails) {
      this.deletedCriteriaList.push(criteria.criteriaDetails.id);
      this.updatedJbiCriteriaList = this.updatedJBICriteriaForExistingCriteria.filter(
        (JBIcriteria: JBICriteriaDTO) =>
          JBIcriteria.connectPlusCriteriaId !== criteria.criteriaDetails.id,
      );
      this.showUpdatedJbiCriteriaNotification =
        this.updatedJbiCriteriaList.length > 0 ? true : false;
    }
  }

  public updateProjectCriteriaHandler() {
    if (this.draftProjectId && this.deletedCriteriaList.length > 0) {
      // Only update deleted criteria on draft project
      // Add/edit criteria on Save as Draft or on Create Project
      this.updateProjectCriterias({
        projectId: Number(this.draftProjectId),
        criteriaList: this.selectedCriteriaArray,
        deletedCriteriaIds: this.deletedCriteriaList,
      });
    }
  }

  get updatedJBICriteriaForExistingCriteria(): JBICriteriaDTO[] {
    return [
      ...this.updatedJBICriteriaListWithAcknowledgment.updatedJBICriteria,
      ...this.updatedJBICriteriaListWithAcknowledgment.deletedJBICriteria,
    ];
  }

  @Watch('updatedJBICriteriaListWithAcknowledgment')
  @isTruthy
  public watchUpdatedJbiCriteriaResponse(): void {
    if (this.draftProjectId && this.projectDetail) {
      this.updatedJbiCriteriaList = this.updatedJBICriteriaForExistingCriteria;
      this.transformCriterias(this.projectDetail.criterias);
      this.stepsIndex = this.stepCalculator();
      this.showUpdatedJbiCriteriaNotification =
        this.updatedJbiCriteriaList.length > 0 ? true : false;
    }
  }

  private confirmStay() {
    return window.confirm(
      'Do you really want to leave? you have unsaved changes!',
    );
  }

  private beforeRouteLeave(to: Route, from: any, next: (_?: boolean) => void) {
    // if new project has changed
    if (!this.draftProjectId && this.contentHasChanged()) {
      // skip route leave confirmation if project is saved or save as draft
      if (this.isCreated) {
        return next();
      }
      return next(this.confirmStay());
    }
    next();
  }

  private onBeforeUnload(e: any) {
    if (!this.draftProjectId && this.contentHasChanged()) {
      return '';
    }
  }

  private created() {
    window.onbeforeunload = this.onBeforeUnload;
  }

  private beforeDestroy() {
    window.onbeforeunload = null;
  }
}
